import React from 'react';
import headerActions from '../../../actions/header';
import translate from '../../../utils/translate';
import SearchResults from '../searchresults';
const T = React.PropTypes;

export default class HeaderSearch extends React.Component {
  static propTypes = {
    suggest:          T.object,
    closeOtherPanels: T.bool,
    search:           T.object,
    searchResults:    T.array,
    searchTerm:       T.string
  };

  state = {
    searchTerm: this.props.searchTerm
  };

  clearSearchTerm = (e) => {
    this.refs.searchinput.focus();
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    this.setState({searchTerm: ''});
    headerActions.clearSearch();
  };

  triggerSearch = (e) => {
    const searchTerm = e.target.value;
    // constiations have the exposed search
    // therefore they close the other panels when you start searching
    this.setState({ searchTerm: searchTerm });
    headerActions.search(this.props.suggest.suggestUrl, searchTerm, this.props.closeOtherPanels);
  };

  renderResults = () => {
    if (this.props.searchResults.length) {
      return <SearchResults searchResults={this.props.searchResults} />;
    }
  };

  renderClearBtn = (constiation) => {
    constiation = constiation || '--outline';
    if (this.props.searchTerm) {
      const className = 'search' + constiation + '__input__clear';
      return (
        <button
          className={className}
          onClick={this.clearSearchTerm}
          type="reset"
          data-component="searchClearBtn"
        />
      );
    }
  };

  validateInput = (event) => {
    if (this.refs.searchinput.value.trim().length === 0) {
      event.preventDefault();
      return false;
    }
  };

  onFocus = () => {
    this.setState({ focused: true });
  }

  onBlur = () => this.setState({ focused: false});

  render () {
    let constiation = '--outline';
    let hiddenInput;

    const containerClass = this.state.focused ? 'search' + constiation + '__focused' : 'search' + constiation;
    const wrapperClass = 'search' + constiation + '__wrapper';
    const inputClass = 'search' + constiation + '__input';
    const buttonClass = 'search' + constiation + '__button';
    const buttonTextClass = 'search' + constiation + '__button__text';

    if (this.props.search.languageParameter) {
      hiddenInput = <input type="hidden" name="language" value={this.props.search.languageParameter} />;
    }

    return (
      <form
        onSubmit={this.validateInput}
        action={this.props.search.searchUrl}
        method="GET"
        className={containerClass}
        data-component="searchForm">
        <div className={wrapperClass}>
          <label className="search__label">
            {translate('searchModule', 'SEARCH')}
          </label>

          <input
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            ref="searchinput"
            placeholder={translate('searchModule', 'SEARCH_DEFAULT')}
            title={translate('searchModule', 'SEARCH_DEFAULT')}
            className={inputClass}
            name="keyword"
            value={this.state.searchTerm}
            autoComplete={this.props.search.toggleAutoComplete}
            onChange={this.triggerSearch}
            data-component="searchInput"
          />
          {this.renderClearBtn(constiation)}
          {hiddenInput}
        </div>

        <button className={buttonClass} data-component="searchSubmitBtn">
          <span className={buttonTextClass}>
            {translate('searchModule', 'SEARCH_SUBMIT')}
          </span>
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/searchinput/index.js